/* eslint react/forbid-prop-types: 0 */
import React, { Component } from "react";
import PropTypes from "prop-types";
import { Link } from "react-router-dom";
import moment from "moment";
import { Glyphicon } from "react-bootstrap";
import AssociateAction from "./actions/AssociateAction";
import RunsheetStatus from "./RunsheetStatus";
import CancelAction from "./RunsheetCancel";

const ViewLink = ({ path, id }) => (
  <Link className="custom-link" title="View" to={`${path}/${id}`}>
    <Glyphicon glyph="eye-open" />
  </Link>
);
ViewLink.propTypes = {
  path: PropTypes.string.isRequired,
  id: PropTypes.number.isRequired
};

const EditLink = ({ path, id }) => (
  <Link className="custom-link" to={`${path}/${id}/edit`} title="Edit">
    <Glyphicon glyph="pencil" />
  </Link>
);
EditLink.propTypes = {
  path: PropTypes.string.isRequired,
  id: PropTypes.number.isRequired
};

const CopyLink = ({ path, id }) => (
  <Link className="custom-link" to={`${path}/${id}/copy`} title="Copy">
    <Glyphicon glyph="duplicate" />
  </Link>
);
CopyLink.propTypes = {
  path: PropTypes.string.isRequired,
  id: PropTypes.number.isRequired
};

const UserDisplay = ({ user }) => (
  <span>{`${user.firstName} ${user.lastName}`}</span>
);
UserDisplay.propTypes = {
  user: PropTypes.object
};
UserDisplay.defaultProps = {
  user: { firstName: "", lastName: "" }
};

class RunsheetTableItem extends Component {
  getActions = (status, args) => {
    const { path, id } = args;
    if (status === "CREATED" || status === "OPENED") {
      return (
        <ul className="list-inline">
          <li>
            <ViewLink path={path} id={id} />
          </li>
          <li>
            <EditLink path={path} id={id} />
          </li>
          <li>
            <AssociateAction
              runsheet={this.props.runsheet}
              allocateRunsheet={this.props.allocateRunsheet}
              updateVehicle={this.props.updateVehicle}
              removeVehicle={this.props.removeVehicle}
            />
          </li>
          <li>
            <CopyLink path={path} id={id} />
          </li>
          <li>
            <CancelAction
              runsheet={this.props.runsheet}
              cancelRunsheet={this.props.cancelRunsheet}
            />
          </li>
        </ul>
      );
    }
    return (
      <ul className="list-inline">
        <li>
          <ViewLink path={path} id={id} />
        </li>
      </ul>
    );
  };

  render() {
    const { runsheet, matchPath } = this.props;
    const { id, status } = runsheet;
    const actions = this.getActions(status, {
      path: matchPath,
      id
    });
    const scheduledAtDisplay = moment(runsheet.scheduledAt).format(
      "D MMM YYYY"
    );

    return (
      <tr className="runsheets-table-body">
        <td>
          <RunsheetStatus
            status={this.props.runsheet.status}
            jobs={this.props.runsheet.jobs}
          />
        </td>
        <td>{runsheet.externalId || ""}</td>
        <td>{runsheet.name}</td>
        <td>{runsheet.vehicle ? <span>{runsheet.vehicle.name}</span> : ""}</td>
        <td>
          <UserDisplay user={runsheet.user} />
        </td>
        <td>{scheduledAtDisplay}</td>
        <td>{actions}</td>
      </tr>
    );
  }
}
RunsheetTableItem.propTypes = {
  runsheet: PropTypes.object.isRequired,
  matchPath: PropTypes.string.isRequired,
  cancelRunsheet: PropTypes.func.isRequired,
  allocateRunsheet: PropTypes.func.isRequired,
  updateVehicle: PropTypes.func.isRequired,
  removeVehicle: PropTypes.func.isRequired
};

export default RunsheetTableItem;



// WEBPACK FOOTER //
// ./src/components/runsheets/list/RunsheetTableItem.js